import { call, put, takeLatest } from 'redux-saga/effects';
import { PayloadAction } from '@reduxjs/toolkit';

import { fetchTrackingApi } from './tracking.api';
import { fetchTrackingFailure, fetchTrackingRequest, fetchTrackingSuccess } from './tracking.slice';

import { ShipmentTrackingInfo } from '@stone/interfaces';
import { handleSagaError } from '@stone/sagaHelpers';

function* fetchTrackingSaga(action: PayloadAction<number>): Generator<any, void, any> {
  try {
    const response: ShipmentTrackingInfo = yield call(fetchTrackingApi, action.payload);
    yield put(fetchTrackingSuccess({ id: action.payload, data: response }));
  } catch (error: any) {
    yield handleSagaError(error, fetchTrackingFailure, 'Failed to fetch tracking info');
  }
}

export default function* trackingSaga() {
  yield takeLatest(fetchTrackingRequest.type, fetchTrackingSaga);
}
